import { type ChangeEvent, type FC, useMemo } from "react";

import type { FormInputProps } from "../../../components/Form/types/types";
import { InputTextStyle } from "../../../documentation/styles/InputStyle";

interface PasswordInputProps extends FormInputProps<string> {
    readOnly?: boolean;
}

export const PasswordInput: FC<PasswordInputProps> = ({ onChange, readOnly, ...restProps }) => {
    const onValueChange = (ev: ChangeEvent<HTMLInputElement>) => {
        if (onChange) {
            onChange(ev.target.value);
        }
    };
    const className = useMemo(
        () => (readOnly ? "aevi-input aevi-input-text aevi-input-disabled" : "aevi-input aevi-input-text"),
        [readOnly],
    );

    return <InputTextStyle type="password" className={className} disabled={readOnly} onChange={onValueChange} {...restProps} />;
};
